import React from "react";
import Theme from "./theme";
import App from "./app";
import { Search } from "/app/src/components/generic/components/search";

/**
 * Filters component renders report list filters including search, themes, and app filtering.
 *
 * @param {Object} props - Component props.
 * @param {Array<{name: string, value: string}>} props.themes - Array of theme objects.
 * @param {function} props.setSearchString - Function to update the search string.
 * @param {function} props.setSelectedTheme - Function to set the selected theme.
 * @param {function} props.setSelectedApp - Function to set the selected application.
 * @returns {JSX.Element} A React component representing the filters.
 */
export default function Filters({
  themes,
  setSearchString,
  setSelectedTheme,
  setSelectedApp,
}: {
  themes: { name: string; value: string }[];
  setSearchString: (string: string) => void;
  setSelectedTheme: (string: string) => void;
  setSelectedApp: (string: string) => void;
}) {
  return (
    <div className="reportListFilters">
      <Search setSearchString={setSearchString} />
      <Theme themes={themes} setSelectedTheme={setSelectedTheme} />
      <App setSelectedApp={setSelectedApp} />
    </div>
  );
}
